const GRENKE_FACTOR_TABLE = {
	12: [8.979, 8.885, 8.792, 8.722, 8.676],
	18: [6.192, 6.098, 6.006, 5.937, 5.891],
	24: [4.801, 4.707, 4.614, 4.546, 4.5],
	30: [3.97, 3.875, 3.781, 3.712, 3.666],
	36: [3.418, 3.321, 3.227, 3.157, 3.111],
	42: [3.025, 2.928, 2.832, 2.761, 2.714],
	48: [2.733, 2.633, 2.536, 2.465, 2.418],
	60: [2.327, 2.224, 2.125, 2.052, 2.004],
};
const GRENKE_EUR_BANDS = [5000, 12500, 25000, 50000, Infinity];

function grenkeGetFactor(months, valueEur) {
	const row = GRENKE_FACTOR_TABLE[months];
	if (!row) return null;
	const idx = GRENKE_EUR_BANDS.findIndex((max) => valueEur <= max);
	return row[idx >= 0 ? idx : row.length - 1];
}

if (!customElements.get('grenke-calculator')) {
	class GrenkeCalculator extends HTMLElement {
		connectedCallback() {
			this._input = this.querySelector('[data-grenke-value]');
			this._monthly = this.querySelector('[data-grenke-monthly]');
			this._monthlyRon = this.querySelector('[data-grenke-monthly-ron]');
			this._cta = this.querySelector('.grenke-calc__cta');
			this._eurRate = parseFloat(this.dataset.eurRate || '0') || 5.0;
			this._activeMonths = 36;
			this._priceRon = 0;

			// Collapsible toggle (product page variant)
			const toggle = this.querySelector('.grenke-pcalc__toggle');
			if (toggle) {
				const panelId = toggle.getAttribute('aria-controls');
				const panel = panelId ? document.getElementById(panelId) : null;
				if (panel) {
					toggle.addEventListener('click', () => {
						const open = toggle.getAttribute('aria-expanded') === 'true';
						toggle.setAttribute('aria-expanded', String(!open));
						panel.hidden = open;
					});
				}
			}

			// Details dialog
			const dialogId = this.dataset.dialogId;
			if (dialogId) {
				const dialog = document.getElementById(dialogId);
				if (dialog) {
					this.querySelectorAll('[data-grenke-details-open]').forEach((btn) => {
						btn.addEventListener('click', () => dialog.showModal());
					});
					dialog.addEventListener('click', (e) => {
						if (e.target === dialog) dialog.close();
					});
					dialog.querySelectorAll('[data-grenke-details-close]').forEach((btn) => {
						btn.addEventListener('click', () => dialog.close());
					});
				}
			}

			const defaultBtn = this.querySelector('.grenke-calc__duration-btn.is-active');
			if (defaultBtn) {
				this._activeMonths = parseInt(defaultBtn.dataset.grenkeMonths, 10) || 36;
			}

			this.querySelectorAll('[data-grenke-months]').forEach((btn) => {
				btn.addEventListener('click', () => {
					this.querySelectorAll('[data-grenke-months]').forEach((b) => {
						b.classList.remove('is-active');
						b.setAttribute('aria-pressed', 'false');
					});
					btn.classList.add('is-active');
					btn.setAttribute('aria-pressed', 'true');
					this._activeMonths = parseInt(btn.dataset.grenkeMonths, 10) || 36;
					this._calculate();
				});
			});

			this._input?.addEventListener('input', () => this._calculate());

			document.addEventListener('variant:changed', (event) => {
				const price = event.detail?.variant?.price;
				if (price != null) {
					if (this._input) {
						this._input.value = Math.round(price / 100);
					} else {
						this._priceRon = Math.round(price / 100);
					}
					this._calculate();
				}
			});

			const preloadPrice = this.dataset.price;
			if (preloadPrice) {
				if (this._input && !this._input.value) {
					this._input.value = Math.round(parseInt(preloadPrice, 10) / 100);
				} else if (!this._input) {
					this._priceRon = Math.round(parseInt(preloadPrice, 10) / 100);
				}
			}

			this._calculate();
		}

		_calculate() {
			if (!this._monthly) return;

			const valueRon = this._input ? parseFloat(this._input.value) || 0 : this._priceRon;

			if (valueRon <= 0) {
				this._monthly.textContent = '—';
				if (this._monthlyRon) this._monthlyRon.textContent = '';
				this._updateCtaLink(0, this._activeMonths);
				return;
			}

			const eurRate = this._eurRate;
			const valueEur = valueRon / eurRate;
			const factor = grenkeGetFactor(this._activeMonths, valueEur);

			if (!factor) {
				this._monthly.textContent = '—';
				if (this._monthlyRon) this._monthlyRon.textContent = '';
				return;
			}

			const monthlyEur = (valueEur * factor) / 100;
			const monthlyRon = monthlyEur * eurRate;

			if (this.hasAttribute('data-round-eur')) {
				this._monthly.textContent = `≈ ${Math.ceil(monthlyEur).toLocaleString('ro-RO')}`;
			} else {
				this._monthly.textContent = monthlyEur.toLocaleString('ro-RO', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				});
			}

			if (this._monthlyRon) {
				this._monthlyRon.textContent = `≈ ${monthlyRon.toLocaleString('ro-RO', {
					minimumFractionDigits: 0,
					maximumFractionDigits: 0,
				})} RON/lună`;
			}

			this._updateCtaLink(valueRon, this._activeMonths);
		}

		_updateCtaLink(value, months) {
			if (!this._cta) return;

			const base = this._cta.dataset.baseHref || this._cta.getAttribute('href');
			if (!this._cta.dataset.baseHref) this._cta.dataset.baseHref = base;
			if (!base || base.startsWith('#')) return;

			const url = new URL(base, window.location.origin);
			if (value > 0) {
				url.searchParams.set('valoare', Math.round(value));
				url.searchParams.set('durata', months);
				url.searchParams.set('view', 'grenke');
				const productTitle = this.dataset.productTitle;
				if (productTitle) {
					url.searchParams.set('product', productTitle);
					url.searchParams.set('product_price', Math.round(value));
				}
			} else {
				url.searchParams.delete('valoare');
				url.searchParams.delete('durata');
				url.searchParams.delete('product');
				url.searchParams.delete('product_price');
			}
			url.hash = 'grenke-formular';

			this._cta.href = url.pathname + (url.search || '') + url.hash;
		}
	}

	customElements.define('grenke-calculator', GrenkeCalculator);
}
